<template>
  <div class="col-sm-12 remove-margins">
    <h2 class="text-center hidden-sm hidden-xs">
      <i class="fa fa-bookmark-o" /> Bookings
    </h2>
    <h3 class="text-center hidden-md hidden-lg">
      <i class="fa fa-bookmark-o" /> Bookings
    </h3>
    <div>
      <hr
        style="margin-top: 0px; margin-bottom: 0px"
        class="hidden-xs hidden-sm"
      />
    </div>
    <ConfirmedReservations></ConfirmedReservations>
  </div>
</template>

<script>
import PetSelectCard from "../../SharedComponents/PetSelectCard";
import ConfirmedReservations from "./components/ConfirmedReservations";

const API_URL = "https://www.dupaws.com/services/";
export default {
  name: "myReservations",
  data() {
    return {};
  },
  components: {
    ConfirmedReservations,
  },
  updated() {
    // $zopim(function (){
    //     $zopim.livechat.sendVisitorPath();
    // });
  },
  mounted: function () {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// MyReservations.vue?44d8b5bb